import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
const { logout, refreshDashboardData, appLoading } = useAuth();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [userData, setUserData] = useState(null);
  const [exposure, setExposure] = useState(0);
  const [loading, setLoading] = useState(false);
  const [betHistory, setBetHistory] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [headerRefreshing, setHeaderRefreshing] = useState(false);


  // App download link

  // Menu items including logout
  const menuItems = [
    { icon: '🏠', label: 'Home', path: '/' },
    { icon: '💰', label: 'Deposit Amount', path: '/deposit' },
    { icon: '💳', label: 'Withdraw Amount', path: '/withdraw' },
    { icon: '📋', label: 'Withdrawal History', path: '/withdraw-history' },
    { icon: '📊', label: 'Bet History', path: '/bet-history' },
    { icon: '🔐', label: 'Change password', path: '/change-password' },
    { icon: '🏦', label: 'Bank Details', path: '/bank-details' },
    { icon: '📑', label: 'Account Statement', path: '/account-statement' },
    { icon: '📞', label: 'Contact Us', path: '/contact-us' },
    {
  icon: '⬇️',
  label: 'Download App',
  action: () => {
    const link = document.createElement('a');
    link.href = '/playinbyd.apk';   // ya Google Drive link
    link.download = 'playinbyd.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setShowProfileMenu(false);
    setShowSidebar(false);
  }
},

    { type: 'divider' },
    // {
    //   icon: '📱',
    //   label: 'Download App',
    //   type: 'download',
    //   action: () => {
    //     window.open(appDownloadLink, '_blank');
    //     setShowProfileMenu(false);
    //     setShowSidebar(false);
    //   }
    // },
    // { type: 'divider' },
    {
      icon: '🚪',
      label: 'Logout',
      type: 'logout',
      action: () => {
        logout();
        navigate('/login');
        setShowProfileMenu(false);
        setShowSidebar(false);
      }
    }
  ];
  

  // Fetch user data from localStorage
  useEffect(() => {
    const fetchUserData = () => {
      try {
        const storedUserData = localStorage.getItem('userData');
        if (storedUserData) {
          const parsedData = JSON.parse(storedUserData);
          setUserData(parsedData);
        }
      } catch (error) {
        console.error('Error fetching user data from localStorage:', error);
      }
    };

    fetchUserData();
    window.addEventListener('storage', fetchUserData);
    return () => window.removeEventListener('storage', fetchUserData);
  }, []);

  useEffect(() => {
    const fetchBetHistory = async () => {
      if (!userData?.unique_jwt_token) return;
  
      setLoading(true);
      try {
        const response = await fetch('https://playinbyd.com/api/api-bid-history-data', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            app_key: "SgRTXsywVmWteEBLlYWecwgbDiHwlh",
            env_type: "Prod",
            limit: 35,
            page: 1,
            gameListId: ["690c539e83086cf47ccc733b", "68d4fd30d37a8648768b5c01"],
            session: "Open",
            unique_jwt_token: userData.unique_jwt_token
          })
        });
  
        const data = await response.json();
        
        if (data.status === 1 && data.data) {
          setBetHistory(data.data.bidHistory || []);
          setTotalBets(data.data.totalRecords || 0);
          calculateExposure(data.data.bidHistory || []);
        } else {
          console.error('Error fetching bet history:', data.message);
          setBetHistory([]);
          setExposure(0);
        }
      } catch (error) {
        console.error('Error fetching bet history:', error);
        setBetHistory([]);
        setExposure(0);
      } finally {
        setLoading(false);
      }
    };
  
    if (userData?.unique_jwt_token) {
      fetchBetHistory();
    }
    
    // Refresh every 30 seconds to get updated exposure
    const intervalId = setInterval(() => {
      if (userData?.unique_jwt_token) {
        fetchBetHistory();
      }
    }, 30000);
  
    return () => clearInterval(intervalId);
  }, [userData]);

  // Calculate exposure from bet history
  const calculateExposure = (bets) => {
    if (!bets || !Array.isArray(bets)) {
      setExposure(0);
      return;
    }

    try {
      // Filter active/pending/open bets
      const activeBets = bets.filter(bet => {
        const status = bet.status?.toLowerCase();
        return status === 'active' || status === 'pending' || status === 'open';
      });

      // Calculate total exposure
      const totalExposure = activeBets.reduce((total, bet) => {
        const stake = parseFloat(bet.amount) || parseFloat(bet.bidAmount) || 0;
        // If bet has potential loss calculation, use it, otherwise use stake
        const potentialLoss = parseFloat(bet.exposure) || stake;
        return total + potentialLoss;
      }, 0);

      setExposure(totalExposure);
    } catch (error) {
      console.error('Error calculating exposure:', error);
      setExposure(0);
    }
  };
const handleHeaderRefresh = async () => {
  if (headerRefreshing || appLoading) return;

  setHeaderRefreshing(true);
  try {
    await refreshDashboardData(true); // force refresh
  } catch (err) {
    console.error("Header refresh failed", err);
  } finally {
    setHeaderRefreshing(false);
  }
};


const handleProfileClick = () => {
  
  // Refresh user data when opening profile menu
  refreshUserData();
  setShowProfileMenu(!showProfileMenu);
};
const handleNavigation = (path) => {
  // Refresh user data before navigation
  refreshUserData();
  navigate(path);
  setShowProfileMenu(false);
  setShowSidebar(false);
};

  const handleMenuItemClick = (item) => {
    if (item.action) {
      item.action();
    } else if (item.path) {
      handleNavigation(item.path);
    }
  };

  // Format currency (Indian Rupees)
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount || 0);
  };

  // Format exposure
  const formatExposure = (amount) => {
    if (amount === 0) return '₹0';
    return formatCurrency(amount);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current && 
        !menuRef.current.contains(event.target) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target)
      ) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Get user initial for avatar
  const getUserInitial = () => {
    if (userData?.user_name) {
      return userData.user_name.charAt(0).toUpperCase();
    } else if (userData?.mobile) {
      return userData.mobile.charAt(0);
    } else if (userData?.username) {
      return userData.username.charAt(0).toUpperCase();
    }
    return 'U';
  };

  // Get user display name
  const getUserDisplayName = () => {
    if (userData?.user_name) {
      return userData.user_name;
    } else if (userData?.username) {
      return userData.username;
    } else if (userData?.mobile) {
      return userData.mobile;
    }
    return 'User';
  };

  // Get user mobile number
  const getUserMobile = () => {
    return userData?.mobile || userData?.phone || 'No phone number';
  };

  // Get user balance
  const getUserBalance = () => {
    if (userData?.balance !== undefined) {
      return parseFloat(userData.balance) || 0;
    } else if (userData?.wallet_balance !== undefined) {
      return parseFloat(userData.wallet_balance) || 0;
    } else if (userData?.wallet !== undefined) {
      return parseFloat(userData.wallet) || 0;
    }
    return 0;
  };

  // Get active bets count
  const getActiveBetsCount = () => {
    if (!betHistory || !Array.isArray(betHistory)) return 0;
    return betHistory.filter(bet => {
      const status = bet.status?.toLowerCase();
      return status === 'active' || status === 'pending' || status === 'open';
    }).length;
  };
const refreshUserData = () => {
  try {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      setUserData(parsedData);
      return parsedData;
    }
  } catch (error) {
    console.error('Error refreshing user data:', error);
  }
  return null;
};

  // Render menu items
  const renderMenuItems = () => {
    return menuItems.map((item, index) => {
      if (item.type === 'divider') {
        return <div key={`divider-${index}`} className="menu-divider"></div>;
      }
      
      return (
        <button 
          key={index}
          className={`menu-item ${item.type === 'logout' ? 'logout' : ''}`}
          onClick={() => handleMenuItemClick(item)}
        >
          <span className="menu-icon">{item.icon}</span>
          <span>{item.label}</span>
        </button>
      );
    });
  };



  return (
    <>
      <header className="header">
        <div className="header-left">
          <div 
            className="header-logo" 
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            <div className="logo-image-wrapper">
              <img 
                src="/logo1.png" 
                className="header-logo-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = `
                    <div class="logo-fallback" style="
                      width: 40px;
                      height: 40px;
                      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                      border-radius: 10px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 18px;
                      color: white;
                      font-weight: bold;
                      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                    ">
                      BP
                    </div>
                  `;
                }}
              />
            </div>
            <div className="logo-text">
            </div>
          </div>
          
          {/* <div className="header-breadcrumb">
            <span 
              className="breadcrumb-home"
              onClick={() => navigate('/')}
            >
              Dashboard
            </span>
            <span className="breadcrumb-separator">›</span>
            <span className="breadcrumb-current">{getBreadcrumbText()}</span>
          </div> */}
        </div>
        
        <div className="header-right">
          <button
  className="header-refresh-btn"
  onClick={handleHeaderRefresh}
  disabled={headerRefreshing || appLoading}
  title="Refresh dashboard"
>
  {headerRefreshing || appLoading ? '🔄' : '🔄'}
</button>
          <div className="balance-info">
            <div className="balance-item">
              <span className="balance-label">Balance</span>
              <span className={`balance-value ${loading ? 'balance-loading' : ''}`}>
                {loading ? '...' : formatCurrency(getUserBalance())}
              </span>
            </div>
            <div className="balance-item">
              <span className="balance-label">Exposures</span>
              <span className={`balance-value ${loading ? 'balance-loading' : ''} ${exposure > 0 ? 'exposure-warning' : ''}`}>
                {loading ? '...' : formatExposure(exposure)}
              </span>
            </div>
            
            {/* App Download Button */}
            <div className="download-app-button-container">
  <a
    href="/playinbyd.apk"
    className="download-app-button"
    title="Download Mobile App"
    download
  >
    <span className="download-icon">📱</span>
    <span className="download-text">Download App</span>
  </a>
</div>
          </div>
          
          {/* <div className="notification-bell">
            <span>🔔</span>
            <div className="notification-badge"></div>
          </div> */}
          
          <div className="profile-section">
            <button 
              ref={buttonRef}
              className={`profile-button ${showProfileMenu ? 'active' : ''}`}
              onClick={handleProfileClick}
            >
              <div className="user-avatar-initial">
                {getUserInitial()}
              </div>
              <span className="user-name">{getUserDisplayName()}</span>
              <span className="dropdown-arrow">▼</span>
            </button>
            
            {showProfileMenu && (
              <div className="profile-menu" ref={menuRef}>
                <div className="profile-menu-header">
                  {/* <div className="user-avatar-large">
                    {getUserInitial()}
                  </div> */}
                  <div className="user-details">
                    <h4>{getUserDisplayName()}</h4>
                    <p>{getUserMobile()}</p>
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: '8px',
                      fontSize: '12px',
                      opacity: 0.9 
                    }}>
                      <span>Balance:</span>
                      <span style={{ fontWeight: 'bold' }}>
                        {formatCurrency(getUserBalance())}
                      </span>
                    </div>
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: '5px',
                      fontSize: '12px',
                      opacity: 0.9 
                    }}>
                      <span>Active Bets:</span>
                      <span style={{ 
                        fontWeight: 'bold',
                        color: exposure > 0 ? '#f56565' : '#037030'
                      }}>
                        {getActiveBetsCount()}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className="profile-menu-items">
                  {renderMenuItems()}
                </div>
              </div>
            )}
          </div>
          
          {/* <button 
            className="mobile-menu-button"
            onClick={() => setShowSidebar(true)}
          >
            ☰
          </button> */}
        </div>
      </header>
      
      {/* Mobile Sidebar */}
      <div 
        className={`sidebar-overlay ${showSidebar ? 'active' : ''}`} 
        onClick={() => setShowSidebar(false)}
      ></div>
      <div className={`sidebar ${showSidebar ? 'active' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img 
              src="/logo.png" 
              alt="BetPro Logo" 
              className="sidebar-logo-image"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = `
                  <div class="logo-fallback" style="
                    width: 40px;
                    height: 40px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    color: white;
                    font-weight: bold;
                  ">
                    BP
                  </div>
                `;
              }}
            />
          </div>
          <button className="close-sidebar" onClick={() => setShowSidebar(false)}>×</button>
        </div>
        <div className="sidebar-menu">
          <div className="profile-menu-items">
            {/* User Info in Sidebar */}
            <div className="sidebar-user-info">
              <div className="user-avatar-large" style={{ margin: '0 auto 15px' }}>
                {getUserInitial()}
              </div>
              <h4 style={{ margin: '0 0 5px 0', color: '#f8fafc' }}>
                {getUserDisplayName()}
              </h4>
              <p style={{ margin: '0 0 10px 0', color: '#94a3b8', fontSize: '14px' }}>
                {getUserMobile()}
              </p>
              {loading ? (
                <div style={{ color: '#a0aec0', fontSize: '12px' }}>
                  Loading...
                </div>
              ) : (
                <>
                  <div className="sidebar-balance-item">
                    <span>Balance:</span>
                    <span className="balance-value">
                      {formatCurrency(getUserBalance())}
                    </span>
                  </div>
                  <div className={`sidebar-balance-item ${exposure > 0 ? 'exposure-warning' : ''}`}>
                    <span>Exposure:</span>
                    <span>
                      {formatExposure(exposure)}
                    </span>
                  </div>
                </>
              )}
            </div>
            
            <div className="menu-divider"></div>
            
            {renderMenuItems()}
            
            <div className="menu-divider"></div>
            
            <div className="sidebar-stats">
              <div className="stats-item">
                <span className="stats-label">Total Bets</span>
                <span className="stats-value">{totalBets}</span>
              </div>
              <div className="stats-item">
                <span className="stats-label">Active Bets</span>
                <span className={`stats-value ${getActiveBetsCount() > 0 ? 'active-bets-warning' : ''}`}>
                  {getActiveBetsCount()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;